import React from "react";
import {Field, FieldArray, reduxForm} from "redux-form/immutable";
import {fromJS} from "immutable";
import ActionButton from "../../../components/ActionButton";
import FormFieldsTable from "../../../components/forms/FormFieldsTable";
import TextInputField from "../../../components/forms/TextInputField";
import TextAreaInputField from "../../../components/forms/TextAreaInputField";
import DropDownInputField from "../../../components/forms/DropDownInputField";
import FormError from "../../../components/forms/FormError";
import LinesField from "./LinesField";

const transportTypes = fromJS([
  {id: "truck", label: "Truck"},
  {id: "container", label: "Container"},
  {id: "parcel", label: "Parcel"},
]);

// Creates (with `showLines`) or edits the header of a purchase order. The
// destination can change until the goods are received.
const PurchaseOrderForm = (props) => {
  const {errors, submit, submitting, warehouses, suppliers, products, showLines, submitLabel} = props;
  const label = submitting ? "Standby..." : submitLabel;

  return (
    <form onSubmit={props.handleSubmit}>
      <div className="fields">
        <FormFieldsTable>
          <Field label="Supplier" name="partnerId" component={DropDownInputField}
            data={suppliers} valueKey="partnerId" titleKey="name" showBlank={true} serverError={errors.partnerId} />
          <Field label="Deliver To" name="destinationWarehouseId" component={DropDownInputField}
            data={warehouses} valueKey="id" titleKey="label" showBlank={true} serverError={errors.destinationWarehouseId} />
          <Field label="PO Number" name="poNumber" component={TextInputField} serverError={errors.poNumber} />
          <Field label="Supplier Reference" name="supplierReference" component={TextInputField}
            placeholder="Their order confirmation" serverError={errors.supplierReference} />
          <Field label="Order Date" name="orderDate" type="date" component={TextInputField} serverError={errors.orderDate} />
          <Field label="Expected Delivery" name="expectedDeliveryDate" type="date" component={TextInputField} serverError={errors.expectedDeliveryDate} />
          <Field label="Transport" name="transportType" component={DropDownInputField}
            data={transportTypes} valueKey="id" titleKey="label" showBlank={true} serverError={errors.transportType} />
          <Field label="Truck / Container" name="carrierReference" component={TextInputField} serverError={errors.carrierReference} />
          <Field label="Notes" name="notes" component={TextAreaInputField} rows={3} serverError={errors.notes} />
          {showLines && <FieldArray name="lines" component={LinesField} props={{products}} />}
        </FormFieldsTable>
        {suppliers.size === 0 &&
          <p>No suppliers yet. Add one under Inventory → Clients &amp; Suppliers.</p>}
      </div>
      <FormError error={[errors.lines, errors._error].filter((message) => message).join("\n")} />
      <div className="buttons">
        <ActionButton label={label} onClick={submit} active={!submitting} />
        <ActionButton label="Cancel" active={!submitting} onClick={props.onCancel} />
      </div>
    </form>
  )
}

export default reduxForm({form: "PurchaseOrderForm"})(PurchaseOrderForm);
